<template>
	<div class="center-wrap">
		<div class="left-wrap">
			<div class="bg-wrap"></div>
			<div class="phone-tip">全国服务热线:</div>
			<div class="phone-wrap">{{ telephone }}</div>
		</div>
		<div class="right-wrap">
			<div v-for="parent in descList" :key="parent.title">
				<div class="title" >{{ parent.title }}</div>
				<div v-for="item in parent.list" :key="item" class="detail-wrap">
					<div @click="descListCli(item)" class="detail">{{ item }}</div>
				</div>
			</div>
		</div>
		<el-dialog
				custom-class="sg-login-dialog"
				:visible.sync="dialogVisible"
				title="请先登录"
				width="400px"
			>
				<login @closeLoginDialog="dialogVisible = false"></login>
			</el-dialog>
	</div>
	<!-- <div class="clearfix bottom-link">
    <div class="safe-box">
      <div class="safeguard">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABqlBMVEUAAADo1Z/hzZjl0pziz5nr2aPgzJbdyJLbx5Hq2KHr2aPp16HdyJLeypTq2aLp16Hm053cx5Lbx5Hj0JrfzJbm053fy5Xo1qDcyJLn1J7bx5Hm057dyJPcx5HizpjgzJbeyZPbx5Hp16HfypXgzJbfzJbr2aPm053bxpHr2aPs2qTl0p3eypXhzpjp16HbxpDr2aPk0ZvdyJPo1qCRZ0vz4rDn05/bw43Yv4js2abbx5Hw3qvq1aPy4K7o1aDhy5bex5LJrHTx363q16LjzZnz4a/dx5HUu4Xw3avr2aPm0ZzhypXSt4Du3KjdyJPNsXnYwZPQtX66nHasi2nq2KLm053k0JrlzprhzJffy5XTuoLPs3zGqG+rimfu3KnVu4Tt26jk0pvdyJvbxJbUuoPMr3emg2Hizpjiz5nRuInRtn6YcVPcxpjWvpDTvI3SuozLsYPEqYHKrnXIq3Ln1Z/kz57eyZPYwInKsH/NsXq+oXq4mXS2lm+qh2TizZ/eyJrcxY/bxI3VvYbOtIbGq4PMsX2Yb1Hm06TPtYbCpnzHq3qzlHCwj2vCo2o45zqiAAAANHRSTlMASSgKBtLRNfzgw7yqlpBSQPnr6tvNxrSznJOSj4qJemZHOCIT+u/u3NXHxL+1fHhiYFIrFyt1wAAAAvxJREFUOMul1PdX2lAUB/BIte6tVeu2du/2JpAXiAaEEEcIhCCoIAgFFCfuvard/3PfC5agx9HTfn/+nPveu/cm1H/kXk3Nvb9xteUOR3ntnayvkudTKYe/ou9WVtfCrGkDFvEo4PdX1t3Iil5qmjY84jJbpkddmt9fUXSdKn7fHIsxPD88NDJotoij3uOAXyp5d/VZj7oaAzFGGmOtDJZ6zclPm0FJelJjKrza61Q6vRa1cdwY6yByMCdXJ0KSJFUaN3gQTPEcTTttdjeuyRtSmMqaJelFHt4PRu1OGudCrudPX536tSqVFECWs9toUlPdXVcWFpdmT5e3znJSkJ7nYVPQOua225y08wB2VuAiSYtIThekcqNiiGGjblLTB19WQNFrQtKsy0l/SQEcdrCk5gz46BXgIqRLkHTpcq4AvgoNMVhy9iTM0J+Bc0exhGSu89P+ijysCg0EsIzsgA5VNRwO78O+/nZx09GSh9UbG1haTyED8/SSqqoZwNKXm5HL0ZaH3bJrcGCc2Ttfhnm9nyoY/Qzxb/Lwg4zMWA7NKhA/mMFJwnxcUeL63AO8scUmGVmIZBYgHoZ8wlYiNf6jsWL1ckKXi6AcxueVDFZKPH7IErnGFFPGVsiJCSJnYYGNcD7IQObHnw1hmikjnbI4R+RXWLSyu7CiggI+vHWkn1p7AexFm545fPoyzA79hF23CrQPSzveT0YrKoDFDWjb401YtmDrHPbYiApOLJNRzs1qT/EVjTxEorA9l/gOy75veEZhwBviW3LaOD7WfvmbKUOC4PGe7YmDZJo7YbfNhlvv5GIxE3Up1UicwjLXJcZKdolAPtZGXU5/AxolEr/dldsQDktHoLGfupLeMpTVpV4zJyPp9DX/gLcICYbEp0eiqVR3oTBejjyFkg8Gq6lr04nQxJSw7U2Qe46ng8Eu6ob01KOTrOAh05RDocc91I0pfYaQmPV4p482Qk2lt/6WO8rQsXiCZLnjrt+zqRVh1mqi7k5pVVUp9e/5DS90+XQ/tYaTAAAAAElFTkSuQmCC"
          alt="保障"
        />
        <span>最专业的服务，给您最好的保障</span>
      </div>
      <div class="hotline">
        <h3>全国服务热线</h3>
        <div>
          <h4>400-021-xxxx</h4>
          <p>(周一至周六：09：00~18：00)</p>
        </div>
      </div>
    </div>
    <div class="help-link">
      <dl>
        <dt>新手指南</dt>
        <dd><a href="/help">购物流程</a></dd>
        <dd><a href="/help">品质保障</a></dd>
      </dl>
      <dl>
        <dt>支付方式</dt>
        <dd><a href="/help">在线支付</a></dd>

        <dd><a href="/help">发票说明</a></dd>
      </dl>
      <dl>
        <dt>配送说明</dt>
        <dd><a href="/help">配送政策</a></dd>
        <dd><a href="/help">物流配送</a></dd>
      </dl>
      <dl>
        <dt>售后服务</dt>
        <dd><a href="/help">退换货流程</a></dd>
        <dd><a href="/help">退款流程</a></dd>
      </dl>
    </div>
    <ul class="qrcode">
      <li>
        <img
          src="@/assets/peiqi.png"
          alt="下载app"
        />
        <p>配琪商城小程序</p>
      </li>
      <li>
        <img
          src="@/assets/gzerw.jpg"
          alt="关注公众号"
        />
        <p>扫一扫，关注微信公众号</p>
      </li>
    </ul>
  </div> -->
</template>
<script>
import {telephone} from "@/utils/telephone.js"
import Login from "@/components/Login"

export default {
	components:{
		Login
	},
	data() {
		return {
			telephone: telephone,
			dialogVisible: false,

			descList: [
				{
					title: "购物指南",
					list: ["免费注册", "购物流程", "常见问题"]
				},
				{
					title: "支付方式",
					list: ["在线支付", "线下支付", "延期在线支付"]
				},
				{
					title: "物流配送",
					list: ["运费政策", "物流配送服务", "签收验货", "物流查询"]
				},
				{
					title: "售后服务",
					list: ["退换货政策", "订单修改", "退换货申请", "我的发票"]
				},
				{
					title: "商家服务",
					list: ["合作招商", "广告服务", "商家帮助", "服务市场", "规则中心"]
				}
			]
		}
	},
	methods:{
		descListCli(v){
			// console.log(v)
			var day =''
			switch(v){
				case '免费注册' :
					day = 'WebOMS_Helper_MFZC';
					break;
				case '购物流程' :
					day = 'WebOMS_Helper_GWLC';
					break;
				case '常见问题' :
					day = 'WebOMS_Helper_CJWT';
					break;
				case '在线支付' :
					day = 'WebOMS_Helper_ZXZF';
					break;
				case '线下支付' :
					day = 'WebOMS_Helper_XXZF';
					break;
				case '延期在线支付' :
					day = 'WebOMS_Helper_YQZXZF';
					break;
				case '运费政策' :
					day = 'WebOMS_Helper_YFZC';
					break;
				case '物流配送服务' :
					day = 'WebOMS_Helper_WLPSFW';
					break;
				case '签收验货' :
					day = 'WebOMS_Helper_QSYH';
					break;
				case '物流查询' :
					day = 'WebOMS_Helper_WLCX';
					break;
				case '退换货政策' :
					day = 'WebOMS_Helper_THHZC';
					break;
				case '订单修改' :
					day = 'WebOMS_Helper_DDXG';
					break;
				case '退换货申请' :
					day = 'WebOMS_Helper_THHSQ';
					break;
				case '我的发票' :
					day = 'WebOMS_Helper_WDFP';
					break;
				case '合作招商' :
					day = 'WebOMS_Helper_HZXS';
					break;
				case '广告服务' :
					day = 'WebOMS_Helper_GGFW';
					break;
				case '商家帮助' :
					day = 'WebOMS_Helper_SJBZ';
					break;
				case '服务市场' :
					day = 'WebOMS_Helper_FWSC';
					break;
				case '规则中心' :
					day = 'WebOMS_Helper_GZZX';
					break;
			}
			
			

			this.$router.push({
				path: '/helper',
				query: {
					// url的参数, 类似get请求的传参
					WebOMS_Helper :day
				},
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.center-wrap {
	// padding-top: 105px;
	padding-top: 70px;
	padding-bottom: 45px;
	// padding-right: 50px;
	padding-left: 50px;
	display: flex;
	margin-right: 20px;
	// // padding-right: 50px;
	// // padding-left: 50px;
	// display: grid;
	// grid-template-columns: repeat(2, auto);
	// justify-content: space-around;
	.left-wrap {
		padding-right: 50px;
		border-right: 2px solid rgba(194, 194, 194, 1);
		.bg-wrap {
			width: 303px;
			height: 105px;
			background-image: url("~@/assets/bottom/logo.png");
			background-size: cover;
			background-position: center;
		}
		.phone-tip {
			font-size: 20px;
			font-weight: 600;
			color: rgba(35, 35, 35, 1);
			text-align: center;
			margin-top: 40px;
		}
		.phone-wrap {
			font-size: 48px;
			font-weight: 500;
			color: rgba(254, 118, 72, 1);
		}
	}
	.right-wrap {
		flex: 1;
		display: grid;
		grid-template-columns: repeat(5, auto);
		grid-column-gap: 120px;
		justify-content: flex-end;
		.title {
			font-size: 18px;
			font-weight: 600;
			color: rgba(35, 35, 35, 1);
		}
		.detail-wrap {
			margin-top: 15px;
			cursor: pointer;
			.detail {
				font-size: 16px;
				font-weight: 400;
				color: rgba(35, 35, 35, 1);
			}
		}
	}
}
// .bottom-link {
//   padding: 25px 0;
//   .safe-box {
//     float: left;
//     margin: -3px 88px 0 0;
//     .safeguard {
//       height: 52px;
//       font-size: 0;
//       > img {
//         width: 40px;
//         height: 40px;
//         border: none;
//         vertical-align: top;
//       }
//       span {
//         display: inline-block;
//         margin: 10px 0 0 10px;
//         color: #1a1a1a;
//         font-size: 14px;
//         line-height: 20px;
//       }
//     }
//     .hotline {
//       margin-top: 22px;
//       > h3 {
//         float: left;
//         margin-top: 15px;
//         color: #1a1a1a;
//         font-weight: bold;
//         font-size: 14px;
//       }
//       > div {
//         margin-left: 105px;
//         > h4 {
//           color: #ff4f1a;
//           font-size: 28px;
//         }
//       }
//       p {
//         color: #aaa;
//         font-size: 14px;
//         line-height: 1;
//       }
//     }
//   }
//   .help-link {
//     float: left;
//     > dl {
//       float: left;
//       margin-right: 64px;
//       line-height: 22px;
//       &:last-child {
//         margin-right: 0;
//       }
//     }
//     dt {
//       color: #1a1a1a;
//       font-size: 14px;
//     }
//     dd {
//       margin-top: 5px;
//     }
//   }
//   .qrcode {
//     float: right;
//     > li {
//       float: left;
//       padding: 0 10px;
//       margin-left: 25px;
//       text-align: center;
//     }
//     img {
//       width: 120px;
//       height: 120px;
//     }
//     p {
//       padding: 6px 0;
//     }
//   }
// }
</style>
